import { Identifier } from 'react-admin'

import { postRequest } from './common'

export function markAsNotInterested(id: Identifier) {
  let url = `/api/v1/console/contacted-loads/${id}/not-interested/`
  return postRequest(url)
}
